import { logEvent } from 'utils/amplitude';

import type { ChartPanelTabId } from './chartPanelTabsHelpers';

interface ChartPanelTabsEventBase {
  'proddev.feature.name': string;
  'proddev.team.name': 'aif';
  'practice id': number;
}

const getEventBase = (practiceId: number): ChartPanelTabsEventBase => ({
  'proddev.feature.name': 'Clinical Insights',
  'proddev.team.name': 'aif',
  'practice id': practiceId,
});

export function logElationAITabSwitched(practiceId: number, tab: ChartPanelTabId): void {
  logEvent('Elation AI Tab Switched', {
    ...getEventBase(practiceId),
    tab,
  });
}

export function logElationAITabPinned(
  practiceId: number,
  tab: ChartPanelTabId,
  action: 'pin' | 'unpin',
): void {
  logEvent('Elation AI Tab Pinned', {
    ...getEventBase(practiceId),
    tab,
    action,
  });
}

export function logElationAINavButtonClicked(practiceId: number): void {
  logEvent('Elation AI Nav Button Clicked', getEventBase(practiceId));
}

export function logElationAIWelcomeSuggestionClicked(practiceId: number, suggestion: string): void {
  logEvent('Elation AI Welcome Suggestion Clicked', {
    ...getEventBase(practiceId),
    suggestion,
  });
}
